import { RouteObject } from 'react-router-dom';
import { lazy, Suspense } from 'react';

const Promotions = lazy(() => import('./promotions.tsx'));

export const promotionRoutes: RouteObject[] = [
  {
    path: '',
    element: (
      <Suspense>
        <Promotions />
      </Suspense>
    )
  }
];
